class Api {
  constructor() {
    this.baseUrl = "https://api.ouropreto.genteufv.com.br/";
    //this.baseUrl = "http://localhost:5000/"; // Usar um enumerate
  }

  getDistritos(path) {
    return [
      "Todos",
      "Amarantina",
      "Antônio Pereira",
      "Cachoeira do Campo",
      "Engenheiro Corrêa",
      "Glaura",
      "Miguel Burnier",
      "Ouro Preto",
      "Lavras Novas",
      "Rodrigo Silva",
      "Santa Rita de Ouro Preto",
      "São Bartolomeu",
      "Santo Antônio do Leite",
      "Santo Antônio do Salto",
    ];
  }
  // ============================================== Rotas da página inicial ===================================================================================
  async getPropCadastrada(distrito) {
    const result = await this.getRouteInformation(
      "propCadastrada",
      distrito,
      "Erro ao buscar propriedades cadastradas: "
    );

    return result;
  }

  async getPropProduzindo(distrito) {
    const result = await this.getRouteInformation(
      "propProduzindo",
      distrito,
      "Erro ao buscar propriedades produzindo: "
    );

    return result;
  }

  async getPropNProduzindo(distrito) {
    const result = await this.getRouteInformation(
      "propNaoProduzindo",
      distrito,
      "Erro ao buscar propriedades não produzindo: "
    );

    return result;
  }

  async getImoveisPorProdAgropec(distrito) {
    const result = await this.getRouteInformation(
      "contarProducaoAgropecuaria",
      distrito,
      "Erro ao buscar imoveis por produção agropecuária: "
    );

    return result;
  }

  async getAreaMediaDistrito(distrito) {
    const result = await this.getRouteInformation(
      "areaMediaDistrito",
      distrito,
      "Erro ao buscar imoveis por produção agropecuária: "
    );

    return result;
  }

  async getImoveisPorDistrito() {
    const result = await this.getRouteInformation(
      "contarDistritos",
      "Todos",
      "Erro ao buscar imoveis por distrito: "
    );

    return result;
  }

  // ============================================== Rotas da natureza de produção ===================================================================================
  async getNaturezaProd(
    distrito,
    category,
    subcategoria,
    natureza,
    inscricao,
    proprietario,
    areaMin,
    areaMax,
    prodMin,
    prodMax
  ) {
    const result = await this.getRouteInformationWithFiltersAndLimits(
      "naturezaProducao",
      distrito,
      category,
      subcategoria,
      natureza,
      inscricao,
      proprietario,
      areaMin,
      areaMax,
      prodMin,
      prodMax,
      "Erro ao buscar numero de propriedades: "
    );

    return result;
  }

  async getContarProducao(
    distrito,
    category,
    subcategoria,
    natureza,
    inscricao,
    proprietario,
    areaMin,
    areaMax,
    prodMin,
    prodMax
  ) {
    const result = await this.getRouteInformationWithFiltersAndLimits(
      "contarProducao",
      distrito,
      category,
      subcategoria,
      natureza,
      inscricao,
      proprietario,
      areaMin,
      areaMax,
      prodMin,
      prodMax,
      "Erro ao buscar a contagem de produção: "
    );

    return result;
  }

  async getNumeroPropriedades(
    distrito,
    category,
    subcategoria,
    natureza,
    inscricao,
    proprietario,
    areaMin,
    areaMax,
    prodMin,
    prodMax
  ) {
    const result = await this.getRouteInformationWithFiltersAndLimits(
      "numeroPropriedades",
      distrito,
      category,
      subcategoria,
      natureza,
      inscricao,
      proprietario,
      areaMin,
      areaMax,
      prodMin,
      prodMax,
      "Erro ao buscar numero de propriedades: "
    );

    return result;
  }

  async getAreaMaxima(
    distrito,
    category,
    subcategoria,
    natureza,
    inscricao,
    proprietario
  ) {
    const result = await this.getRouteInformationWithFilters(
      "areaMaximaPropriedades",
      distrito,
      category,
      subcategoria,
      natureza,
      inscricao,
      proprietario,
      null,
      null,
      null,
      null,
      null,
      null,
      "Erro ao buscar área máxima: "
    );

    return result;
  }

  async getProdMaxima(
    distrito,
    category,
    subcategoria,
    natureza,
    inscricao,
    proprietario
  ) {
    const result = await this.getRouteInformationWithFilters(
      "prodMax",
      distrito,
      category,
      subcategoria,
      natureza,
      inscricao,
      proprietario,
      null,
      null,
      null,
      null,
      null,
      null,
      "Erro ao buscar área máxima: "
    );

    return result;
  }

  async getAreaMedia(
    distrito,
    category,
    subcategoria,
    natureza,
    inscricao,
    proprietario,
    areaMin,
    areaMax,
    prodMin,
    prodMax
  ) {
    const result = await this.getRouteInformationWithFiltersAndLimits(
      "areaMediaPropriedades",
      distrito,
      category,
      subcategoria,
      natureza,
      inscricao,
      proprietario,
      areaMin,
      areaMax,
      prodMin,
      prodMax,
      "Erro ao buscar área média: "
    );

    return result;
  }

  async getNumeroPropriedades2(
    distrito,
    category,
    subcategoria,
    natureza,
    inscricao,
    proprietario,
    carroProprioValue,
    energiaEletricaValue,
    abastecimentoAguaValue,
    tipoFossaValue,
    descarteLixoValue,
    descarteEsgotoValue
  ) {
    const result = await this.getRouteInformationWithFilters(
      "numeroPropriedades2",
      distrito,
      category,
      subcategoria,
      natureza,
      inscricao,
      proprietario,
      carroProprioValue,
      energiaEletricaValue,
      abastecimentoAguaValue,
      tipoFossaValue,
      descarteLixoValue,
      descarteEsgotoValue,
      "Erro ao buscar numero de propriedades: "
    );

    return result;
  }

  async getAreaMedia2(
    distrito,
    category,
    subcategoria,
    natureza,
    inscricao,
    proprietario,
    carroProprioValue,
    energiaEletricaValue,
    abastecimentoAguaValue,
    tipoFossaValue,
    descarteLixoValue,
    descarteEsgotoValue
  ) {
    const result = await this.getRouteInformationWithFilters(
      "areaMediaPropriedades2",
      distrito,
      category,
      subcategoria,
      natureza,
      inscricao,
      proprietario,
      carroProprioValue,
      energiaEletricaValue,
      abastecimentoAguaValue,
      tipoFossaValue,
      descarteLixoValue,
      descarteEsgotoValue,
      "Erro ao buscar área média: "
    );

    return result;
  }

  async getProducaoEmKg(
    distrito,
    category,
    subcategoria,
    natureza,
    inscricao,
    proprietario,
    areaMin,
    areaMax,
    prodMin,
    prodMax
  ) {
    const result = await this.getRouteInformationWithFiltersAndLimits(
      "prodTotal",
      distrito,
      category,
      subcategoria,
      natureza,
      inscricao,
      proprietario,
      areaMin,
      areaMax,
      prodMin,
      prodMax,
      "Erro ao buscar a produção total: "
    );

    return result;
  }

  async getProducaoMedia(
    distrito,
    category,
    subcategoria,
    natureza,
    inscricao,
    proprietario,
    areaMin,
    areaMax,
    prodMin,
    prodMax
  ) {
    const result = await this.getRouteInformationWithFiltersAndLimits(
      "producaoMedia",
      distrito,
      category,
      subcategoria,
      natureza,
      inscricao,
      proprietario,
      areaMin,
      areaMax,
      prodMin,
      prodMax,
      "Erro ao buscar a produção média: "
    );

    return result;
  }

  // ============================================== Rotas da página condições gerais ===================================================================================
  async getPossuiCarro(
    distrito,
    category,
    subcategoria,
    natureza,
    inscricao,
    proprietario,
    energiaEletricaValue,
    abastecimentoAguaValue,
    tipoFossaValue,
    descarteLixoValue,
    descarteEsgotoValue
  ) {
    const result = await this.getRouteInformationWithFilters(
      "possuiCarro",
      distrito,
      category,
      subcategoria,
      natureza,
      inscricao,
      proprietario,
      null,
      energiaEletricaValue,
      abastecimentoAguaValue,
      tipoFossaValue,
      descarteLixoValue,
      descarteEsgotoValue,
      "Erro ao buscar dados de propriedades que possuem carro: "
    );
    return result;
  }

  async getEnergiaEletrica(
    distrito,
    category,
    subcategoria,
    natureza,
    inscricao,
    proprietario,
    carroProprioValue,
    abastecimentoAguaValue,
    tipoFossaValue,
    descarteLixoValue,
    descarteEsgotoValue
  ) {
    const result = await this.getRouteInformationWithFilters(
      "energiaEletrica",
      distrito,
      category,
      subcategoria,
      natureza,
      inscricao,
      proprietario,
      carroProprioValue,
      null,
      abastecimentoAguaValue,
      tipoFossaValue,
      descarteLixoValue,
      descarteEsgotoValue,
      "Erro ao buscar dados de propriedades que possuem energia elétrica: "
    );
    return result;
  }

  async getAbastecimentoAgua(
    distrito,
    category,
    subcategoria,
    natureza,
    inscricao,
    proprietario,
    carroProprioValue,
    energiaEletricaValue,
    tipoFossaValue,
    descarteLixoValue,
    descarteEsgotoValue
  ) {
    const result = await this.getRouteInformationWithFilters(
      "abastecimentoAgua",
      distrito,
      category,
      subcategoria,
      natureza,
      inscricao,
      proprietario,
      carroProprioValue,
      energiaEletricaValue,
      null,
      tipoFossaValue,
      descarteLixoValue,
      descarteEsgotoValue,
      "Erro ao buscar dados de propriedades que possuem abastecimento de água: "
    );
    return result;
  }

  async getCaptacaoAgua(
    distrito,
    category,
    subcategoria,
    natureza,
    inscricao,
    proprietario,
    carroProprioValue,
    energiaEletricaValue,
    abastecimentoAguaValue,
    tipoFossaValue,
    descarteLixoValue,
    descarteEsgotoValue
  ) {
    const result = await this.getRouteInformationWithFilters(
      "captacaoAgua",
      distrito,
      category,
      subcategoria,
      natureza,
      inscricao,
      proprietario,
      carroProprioValue,
      energiaEletricaValue,
      abastecimentoAguaValue,
      tipoFossaValue,
      descarteLixoValue,
      descarteEsgotoValue,
      "Erro ao buscar dados de captação de água: "
    );
    return result;
  }

  async getLocalizacaoPropriedades(
    distrito,
    category,
    subcategoria,
    natureza,
    inscricao,
    proprietario,
    areaMin,
    areaMax,
    prodMin,
    prodMax
  ) {
    const result = await this.getRouteInformationWithFiltersAndLimits(
      "dadosPropriedades",
      distrito,
      category,
      subcategoria,
      natureza,
      inscricao,
      proprietario,
      areaMin,
      areaMax,
      prodMin,
      prodMax,
      "Erro ao buscar localização das propriedades: "
    );
    return result?.value;
  }

  async getLocalizacaoPropriedades2(
    distrito,
    category,
    subcategoria,
    natureza,
    inscricao,
    proprietario,
    carroProprioValue,
    energiaEletricaValue,
    abastecimentoAguaValue,
    tipoFossaValue,
    descarteLixoValue,
    descarteEsgotoValue
  ) {
    const result = await this.getRouteInformationWithFilters(
      "dadosPropriedades2",
      distrito,
      category,
      subcategoria,
      natureza,
      inscricao,
      proprietario,
      carroProprioValue,
      energiaEletricaValue,
      abastecimentoAguaValue,
      tipoFossaValue,
      descarteLixoValue,
      descarteEsgotoValue,
      "Erro ao buscar localização das propriedades: "
    );
    return result?.value;
  }

  async getLocalizacaoPropriedades3(distrito) {
    const result = await this.getRouteInformation(
      "dadosPropriedades3",
      distrito,
      "Erro ao buscar localização das propriedades: "
    );
    return result?.value;
  }

  async getTipoFossa(
    distrito,
    category,
    subcategoria,
    natureza,
    inscricao,
    proprietario,
    carroProprioValue,
    energiaEletricaValue,
    abastecimentoAguaValue,
    descarteLixoValue,
    descarteEsgotoValue
  ) {
    const result = await this.getRouteInformationWithFilters(
      "tipoFossa",
      distrito,
      category,
      subcategoria,
      natureza,
      inscricao,
      proprietario,
      carroProprioValue,
      energiaEletricaValue,
      abastecimentoAguaValue,
      null,
      descarteLixoValue,
      descarteEsgotoValue,
      "Erro ao buscar dados de tipo de fossa: "
    );

    return result;
  }

  async getDescarteLixo(
    distrito,
    category,
    subcategoria,
    natureza,
    inscricao,
    proprietario,
    carroProprioValue,
    energiaEletricaValue,
    abastecimentoAguaValue,
    tipoFossaValue,
    descarteEsgotoValue
  ) {
    const result = await this.getRouteInformationWithFilters(
      "descarteLixo",
      distrito,
      category,
      subcategoria,
      natureza,
      inscricao,
      proprietario,
      carroProprioValue,
      energiaEletricaValue,
      abastecimentoAguaValue,
      tipoFossaValue,
      null,
      descarteEsgotoValue,
      "Erro ao buscar dados de descarte de lixo: "
    );

    return result;
  }

  async getDescarteEsgoto(
    distrito,
    category,
    subcategoria,
    natureza,
    inscricao,
    proprietario,
    carroProprioValue,
    energiaEletricaValue,
    abastecimentoAguaValue,
    tipoFossaValue,
    descarteLixoValue
  ) {
    const result = await this.getRouteInformationWithFilters(
      "descarteEsgoto",
      distrito,
      category,
      subcategoria,
      natureza,
      inscricao,
      proprietario,
      carroProprioValue,
      energiaEletricaValue,
      abastecimentoAguaValue,
      tipoFossaValue,
      descarteLixoValue,
      null,
      "Erro ao buscar dados de descarte de esgoto: "
    );

    return result;
  }

  async getFrequenciaExame(distrito) {
    const result = await this.getRouteInformation(
      "frequenciaExame",
      distrito,
      "Erro ao buscar dados de frequencia de exames: "
    );

    return result;
  }

  async getAgroturismo(distrito) {
    const result = await this.getRouteInformation(
      "agroturismo",
      distrito,
      "Erro ao buscar dados de agroturismo: "
    );
    return result;
  }

  async getFormaDeRenda(distrito) {
    const result = await this.getRouteInformation(
      "formaDeRenda",
      distrito,
      "Erro ao buscar dados de forma de renda com agroturismo: "
    );

    return result;
  }

  async getDificuldadeAgroturismo(distrito) {
    const result = await this.getRouteInformation(
      "dificuldadeAgroturismo",
      distrito,
      "Erro ao buscar dados de dificuldade com agroturismo: "
    );

    return result;
  }

  async getInteresseAgroturismo(distrito) {
    const result = await this.getRouteInformation(
      "interesseAgroturismo",
      distrito,
      "Erro ao buscar dados de interesse agroturismo: "
    );

    return result;
  }

  async getNivelEscolaridade(distrito) {
    const result = await this.getRouteInformation(
      "nivelEscolaridade",
      distrito,
      "Erro ao buscar dados de nível de escolaridade: "
    );

    return result;
  }

  async getMatriculaEscola(distrito) {
    const result = await this.getRouteInformation(
      "matriculaEscola",
      distrito,
      "Erro ao buscar dados de matricula em escola: "
    );

    return result;
  }

  async getQualidadeEscolasRurais(distrito) {
    const result = await this.getRouteInformation(
      "qualidadeEscolasRurais",
      distrito,
      "Erro ao buscar dados de qualidade em escolas rurais: "
    );

    return result;
  }

  async getRendaExclusiva(distrito) {
    const result = await this.getRouteInformation(
      "rendaExclusiva",
      distrito,
      "Erro ao buscar dados de renda exclusiva: "
    );

    return result;
  }

  async getCreditoRural(distrito) {
    const result = await this.getRouteInformation(
      "creditoRural",
      distrito,
      "Erro ao buscar dados de credito rural: "
    );

    return result;
  }

  async getPossuiEmpresa(distrito) {
    const result = await this.getRouteInformation(
      "possuiEmpresa",
      distrito,
      "Erro ao buscar dados quem possui empresa: "
    );

    return result;
  }

  async getRendaPrincipalRural(distrito) {
    const result = await this.getRouteInformation(
      "rendaPrincipalRural",
      distrito,
      "Erro ao buscar dados de renda principal rural: "
    );

    return result;
  }

  async getMaiorDificuldade(distrito) {
    const result = await this.getRouteInformation(
      "maiorDificuldade",
      distrito,
      "Erro ao buscar dados de dificuldades: "
    );

    return result;
  }

  async getEmpreendedorismo(distrito) {
    const result = await this.getRouteInformation(
      "empreendedorismo",
      distrito,
      "Erro ao buscar dados de empreendedorismo: "
    );

    return result;
  }

  async getRecebeRecursos(distrito) {
    const result = await this.getRouteInformation(
      "recebeRecursos",
      distrito,
      "Erro ao buscar dados de recebimento de recursos: "
    );

    return result;
  }

  async getAtividadePrincipal(distrito) {
    const result = await this.getRouteInformation(
      "atividadeRural",
      distrito,
      "Erro ao buscar dados de atividade principal rural: "
    );

    return result;
  }

  async getAtendimentoAmbulancia(distrito) {
    const result = await this.getRouteInformation(
      "atendimentoAmbulancia",
      distrito,
      "Erro ao buscar dados de atendimento de ambulância: "
    );

    return result;
  }

  async getSistemaSaude(distrito) {
    const result = await this.getRouteInformation(
      "sistemaSaude",
      distrito,
      "Erro ao buscar dados de sistema de saúde: "
    );

    return result;
  }

  async getUsoMedicamento(distrito) {
    const result = await this.getRouteInformation(
      "usoMedicamentos",
      distrito,
      "Erro ao buscar dados de possui doenças crônicas: "
    );

    return result;
  }

  async getDificuldadeAtendimento(distrito) {
    const result = await this.getRouteInformation(
      "dificuldadeAgendamento",
      distrito,
      "Erro ao buscar dados de possui doenças crônicas: "
    );

    return result;
  }

  async getQualidadeSSMunicipal(distrito) {
    const result = await this.getRouteInformation(
      "qualidadeSaudeMunicipal",
      distrito,
      "Erro ao buscar dados de possui doenças crônicas: "
    );

    return result;
  }

  async getQualidadeSSRural(distrito) {
    const result = await this.getRouteInformation(
      "qualidadeSaudeRural",
      distrito,
      "Erro ao buscar dados de possui doenças crônicas: "
    );

    return result;
  }

  async getPossuiDoencasCronicas(distrito) {
    const result = await this.getRouteInformation(
      "possuiDoencasCronicas",
      distrito,
      "Erro ao buscar dados de possui doenças crônicas: "
    );

    return result;
  }

  async getTipoDoencasCronicas(distrito) {
    const result = await this.getRouteInformation(
      "doencasCronicas",
      distrito,
      "Erro ao buscar dados de tipo de doenças crônicas: "
    );

    return result;
  }

  async getProgramaSaudeRural(distrito) {
    const result = await this.getRouteInformation(
      "programaSaudeRural",
      distrito,
      "Erro ao buscar dados de programa de saúde rural: "
    );

    return result;
  }

  async getNascentes(distrito) {
    const result = await this.getRouteInformation(
      "nascentes",
      distrito,
      "Erro ao buscar dados de nascentes: "
    );

    return result;
  }

  async getNumeroNascentes(distrito) {
    const result = await this.getRouteInformation(
      "numeroNascentes",
      distrito,
      "Erro ao buscar número de nascentes: "
    );

    return result;
  }

  async getAguaCorrente(distrito) {
    const result = await this.getRouteInformation(
      "aguaCorrente",
      distrito,
      "Erro ao buscar dados de água corrente: "
    );

    return result;
  }

  async getMata(distrito) {
    const result = await this.getRouteInformation(
      "mata",
      distrito,
      "Erro ao buscar dados de mata: "
    );

    return result;
  }

  async getTipoMata(distrito) {
    const result = await this.getRouteInformation(
      "tipoMata",
      distrito,
      "Erro ao buscar dados de tipo de mata: "
    );

    return result;
  }

  async getAgrotoxico(distrito) {
    const result = await this.getRouteInformation(
      "agrotoxico",
      distrito,
      "Erro ao buscar dados de uso de agrotóxico: "
    );

    return result;
  }

  async getProblemasSaudeAgrotoxico(distrito) {
    const result = await this.getRouteInformation(
      "problemasSaudeAgrotoxico",
      distrito,
      "Erro ao buscar dados de problemas de saúde causados pelos agrotóxicos: "
    );

    return result;
  }

  async getSituacaoEstradas(distrito) {
    const result = await this.getRouteInformation(
      "situacaoEstradas",
      distrito,
      "Erro ao buscar dados de situação de estradas: "
    );

    return result;
  }

  async getManutencaoEstradas(distrito) {
    const result = await this.getRouteInformation(
      "manutencaoEstradas",
      distrito,
      "Erro ao buscar dados de manutenção de estradas: "
    );

    return result;
  }

  async getInfraestrutura(distrito) {
    const result = await this.getRouteInformation(
      "infraestrutura",
      distrito,
      "Erro ao buscar dados de infraestrutura: "
    );

    return result;
  }

  async getProdutosFabricados(distrito) {
    const result = await this.getRouteInformation(
      "produtosFabricados",
      distrito,
      "Erro ao buscar dados de produtos fabricados: "
    );

    return result;
  }

  async getAssistenciaTecnica(distrito) {
    const result = await this.getRouteInformation(
      "assistenciaTecnica",
      distrito,
      "Erro ao buscar dados de assistência técnica: "
    );

    return result;
  }

  async getRouteInformation(route, distrito, errorMsg) {
    // Montar a URL com parâmetros
    const url = new URL(this.baseUrl + route);

    if (distrito) {
      if (distrito !== "Todos") {
        url.searchParams.append("distrito", distrito);
      }
    }

    return fetch(url)
      .then((res) => {
        if (!res.ok) {
          throw new Error(`Erro HTTP: ${res.status}`);
        }
        return res.json();
      })
      .catch((err) => {
        console.error(errorMsg, err);
        return null;
      });
  }

  async getRouteInformationWithFilters(
    route,
    distrito,
    category,
    subcategoria,
    natureza,
    inscricao,
    proprietario,
    carroProprioValue,
    energiaEletricaValue,
    abastecimentoAguaValue,
    tipoFossaValue,
    descarteLixoValue,
    descarteEsgotoValue,
    errorMsg
  ) {
    // Montar a URL com parâmetros
    const url = new URL(this.baseUrl + route);

    if (distrito) {
      if (distrito !== "Todos") {
        url.searchParams.append("distrito", distrito);
      }
    }

    if (category) {
      url.searchParams.append("categoria", category);
    }

    if (subcategoria) {
      url.searchParams.append("subcategoria", subcategoria);
    }

    if (natureza) {
      url.searchParams.append("natureza", natureza);
    }

    if (inscricao) {
      url.searchParams.append("inscricao", inscricao);
    }

    if (proprietario) {
      url.searchParams.append("proprietario", proprietario);
    }

    if (carroProprioValue) {
      url.searchParams.append("carroProprio", carroProprioValue);
    }

    if (energiaEletricaValue) {
      url.searchParams.append("energiaEletrica", energiaEletricaValue);
    }

    if (abastecimentoAguaValue) {
      url.searchParams.append("abastecimentoAgua", abastecimentoAguaValue);
    }

    if (tipoFossaValue) {
      url.searchParams.append("tipoFossa", tipoFossaValue);
    }

    if (descarteLixoValue) {
      url.searchParams.append("descarteLixo", descarteLixoValue);
    }

    if (descarteEsgotoValue) {
      url.searchParams.append("descarteEsgoto", descarteEsgotoValue);
    }

    return fetch(url)
      .then((res) => {
        if (!res.ok) {
          throw new Error(`Erro HTTP: ${res.status}`);
        }
        return res.json();
      })
      .catch((err) => {
        console.error(errorMsg, err);
        return null;
      });
  }

  async getRouteInformationWithFiltersAndLimits(
    route,
    distrito,
    category,
    subcategoria,
    natureza,
    inscricao,
    proprietario,
    areaMin,
    areaMax,
    prodMin,
    prodMax,
    errorMsg
  ) {
    // Montar a URL com parâmetros
    const url = new URL(this.baseUrl + route);

    if (distrito) {
      if (distrito !== "Todos") {
        url.searchParams.append("distrito", distrito);
      }
    }

    if (category) {
      url.searchParams.append("categoria", category);
    }

    if (subcategoria) {
      url.searchParams.append("subcategoria", subcategoria);
    }

    if (natureza) {
      url.searchParams.append("natureza", natureza);
    }

    if (inscricao) {
      url.searchParams.append("inscricao", inscricao);
    }

    if (proprietario) {
      url.searchParams.append("proprietario", proprietario);
    }

    if (
      areaMin != null &&
      areaMax != null &&
      areaMin >= 0 &&
      areaMax >= areaMin
    ) {
      url.searchParams.append("areaMin", areaMin);
      url.searchParams.append("areaMax", areaMax);
    }

    if (
      prodMin != null &&
      prodMax != null &&
      prodMin >= 0 &&
      prodMax >= prodMin
    ) {
      url.searchParams.append("prodMin", prodMin);
      url.searchParams.append("prodMax", prodMax);
    }

    return fetch(url)
      .then((res) => {
        if (!res.ok) {
          throw new Error(`Erro HTTP: ${res.status}`);
        }
        return res.json();
      })
      .catch((err) => {
        console.error(errorMsg, err);
        return null;
      });
  }
}

// Exporta uma instância única (singleton)
const apiInstance = new Api();
export default apiInstance;
